import { render, staticRenderFns } from "./UploaderButton.vue?vue&type=template&id=6d21e022&scoped=true"
import script from "./UploaderButton.vue?vue&type=script&lang=js"
export * from "./UploaderButton.vue?vue&type=script&lang=js"
import style0 from "./UploaderButton.vue?vue&type=style&index=0&id=6d21e022&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d21e022",
  null
  
)

export default component.exports